<template>
  <div class="view-wrap flex column justify-start p-20">
    <div class="home flex column align-center gap-20 ">
      <div class="header-section">
        <div class="kyc-header flex row space-between align-start">
          <div>
              <div class="kyc-title">FIU Dashboard</div>
          </div>
        </div>
      </div>
      <ConfirmEmail v-if="
          (userInformation 
          && userInformation.email 
          && !userInformation.email_verified)
          && !account_id"
        />
      <div class="flex row gap-20 wrap" >
        <div class="flex column align-start gap-20 flex-1">
          <div class='section personal-info-section flex-1'>
            <div class='section-header main-header'>
              <img src="@/assets/user-info_.svg" style="margin-right: 10px;">

              <div>User Information</div>
            </div>
            <div class="input-section personal-info">
                <InpComponent
                  :noMargin="true"
                  class="input-element"
                  label="Organization Id"
                  type="text" 
                  placeholder="123"
                  :disabled="!!userInformation?.rentity_id || account_id"
                  :key_ref="'rentity_id'"
                  :value="userInformation?.rentity_id"
                  :error="data.rentity_id.error"
                  @inputChange="inputChangeFunc"
                ></InpComponent>
                <InpComponent
                  :noMargin="true"
                  class="input-element"
                    label="Entity Name"
                    type="text"
                    placeholder="Name of the Entity"
                    :disabled="!!userInformation?.rentity_branch || account_id"
                    
                    :key_ref="'rentity_branch'"
                    :value="userInformation?.rentity_branch"
                    :error="data.rentity_branch.error"
                  @inputChange="inputChangeFunc"
                ></InpComponent>
                  <InpComponent
                    :disabled="!!account_id"
                    :noMargin="true"
                    class="input-element"

                    label="Title"
                    type="text"
                    placeholder="Your Title"
                    
                    :key_ref="'title_name'"
                    :value="userInformation?.title_name"
                    :error="data.title_name.error"
                    @inputChange="inputChangeFunc"
                  ></InpComponent>
                <InpComponent
                  :noMargin="true"
                  :disabled="!!account_id"
                  class="input-element"
                    label="First Name"
                    type="text"
                    placeholder="Don"
                    
                    :key_ref="'first_name'"
                    :value="userInformation?.first_name"
                    :error="data.first_name.error"
                  @inputChange="inputChangeFunc"
                ></InpComponent>
                  <InpComponent
                    :noMargin="true"
                    :disabled="!!account_id"
                    class="input-element"
                      label="Last Name"
                      type="text"
                      placeholder="Jon"
                      
                      :key_ref="'last_name'"
                      :value="userInformation?.last_name"
                      :error="data.last_name.error"
                    @inputChange="inputChangeFunc"
                  ></InpComponent>

                  <div class="flex row gap-10 align-center">
                  <InpComponent
                    :noMargin="true"
                    :disabled="!!account_id"
                    class="input-element flex-1"
                      label="Email"
                      type="text"
                      placeholder="youremail@company.com"
                      
                      :key_ref="'email'"
                      :value="userInformation?.email"
                      :error="data.email.error"
                    @inputChange="inputChangeFunc"
                  ></InpComponent>
                    <div v-if="account_id && accountInfo">
                      <button @click="verifyEmail" class="button w-content" v-if="!accountInfo.email_verified">
                      Verify
                      </button>
                      <div class="verified-email" v-else>
                        Verified ✔
                      </div>
                    </div>
                  </div> 


                  <InpComponent
                    :noMargin="true"
                    :disabled="!!account_id"
                    class="input-element"
                      label="Gender"
                      type="options"
                      :options="[{text: 'Male', value: 'Male'}, {text: 'Female', value: 'Female'}]"
                      placeholder="Male"
                      
                      :key_ref="'gender'"
                      :value="userInformation?.gender"
                    @inputChange="inputChangeFunc"
                  ></InpComponent>
                  <div class="input-wrapper date" >
                    <span class='text bd-header'>Birth Date</span>
                    <div class='input-holder'>
                      <InpComponent
                        :noMargin="true"
                    :disabled="!!account_id"
                    class="input-element"
                          label="DD"
                          type="number"
                          
                          :key_ref="'birth_date_day'"
                          :value="userInformation?.birth_date ? userInformation?.birth_date.slice(0,10).split('-')[2] : ''"
                          :max="31"
                          :min="1"
                        @inputChange="inputChangeFunc"
                      ></InpComponent>
                      <div class="dividor">/</div>
                      <InpComponent
                          :noMargin="true"
                          :disabled="!!account_id"
                          class="input-element"
                          label="MM"
                          type="number"
                          
                          :key_ref="'birth_date_month'"
                          :value="userInformation?.birth_date ? userInformation?.birth_date.slice(0,10).split('-')[1] : ''"
                          :max="12"
                          :min="1"
                        @inputChange="inputChangeFunc"
                      ></InpComponent>
                      <div class="dividor">/</div>
                      <InpComponent
                          :noMargin="true"
                          class="input-element"
                          :disabled="!!account_id"
                          label="YYYY"
                          type="number"
                          
                          :key_ref="'birth_date_year'"
                          :max="2004"
                          :value="userInformation?.birth_date ? userInformation?.birth_date.slice(0,10).split('-')[0] : ''"
                        @inputChange="inputChangeFunc"
                      ></InpComponent>
                    </div>
                    <div class='error' v-if="data.birth_date_full.error">{{data.birth_date_full.error}}</div>

                  </div>

                  <InpComponent
                    :noMargin="true"
                    class="input-element"
                      label="Id Number"
                      type="number"
                      placeholder="Identification number"
                      :disabled="!!account_id"
                      
                      :key_ref="'id_number'"
                      :value="userInformation?.id_number"
                      :error="data.id_number.error"
                    @inputChange="inputChangeFunc"
                  ></InpComponent>
                  <InpComponent
                    :noMargin="true"
                    class="input-element"
                      label="Nationality"
                      type="options"
                      :options="Utils && Utils.getCountryList()"
                      placeholder="Canada"
                      :disabled="!!account_id"
                      
                      :key_ref="'nationality'"
                      :value="userInformation?.nationality"
                      :error="data.nationality.error"
                    @inputChange="inputChangeFunc"
                  ></InpComponent>
                  <InpComponent
                    :noMargin="true"
                    class="input-element"
                      label="Occupation"
                      type="text"
                      placeholder="Financial Analyst"
                      :disabled="!!account_id"
                      
                      :key_ref="'occupation'"
                      :value="userInformation?.occupation"
                      :error="data.occupation.error"

                    @inputChange="inputChangeFunc"
                  ></InpComponent>
                  <InpComponent
                    :noMargin="true"
                    class="input-element"
                      label="Pasport Number"
                      type="text"
                      placeholder="number"
                      :disabled="!!account_id"
                      
                      :key_ref="'passport_number'"
                      :value="userInformation?.passport_number"
                      :error="data.passport_number.error"
                    @inputChange="inputChangeFunc"
                  ></InpComponent>
                  <InpComponent
                    :noMargin="true"
                    class="input-element"
                    label="Pasport Country"
                    type="options"
                    :options="Utils && Utils.getCountryList()"
                    placeholder="Canada"
                    :disabled="!!account_id"
                    
                    :key_ref="'pasport_country'"
                    :value="userInformation?.pasport_country"
                    :error="data.pasport_country.error"

                    @inputChange="inputChangeFunc"
                  ></InpComponent>

                  <InpComponent
                    :noMargin="true"
                    class="input-element"
                    label="Local Currency"
                    type="options"
                    :options="consts.currencies_local.map(el => ({text: el, value: el}))"
                    placeholder="Canada"
                    :disabled="!!account_id"
                    :key_ref="'local_currency'"
                    :value="userInformation?.local_currency"
                    :error="data.local_currency.error"
                  
                    @inputChange="inputChangeFunc"
                  ></InpComponent>
            </div>
          </div>

          <div class='section phone-info-section'>
            <div class='section-header main-header'>
              <img src="@/assets/license.svg" style="margin-right: 10px;">

              <div class="flex align-center">Licence</div>
            </div>
            <div class="input-section">
             
                <InpComponent
                  :noMargin="true"
                  class="input-element"
                  label="Issuing Country"
                  type="options"
                  :options="Utils.getCountryList()"
                  :disabled="!!account_id"
                  :key_ref="'issuing_authority'"
                  :value="licenceEl?.issuing_authority"
                  :error="data.issuing_authority.error"

                  @inputChange="inputChangeFunc"
                ></InpComponent>
                <InpComponent
                  :noMargin="true"
                  class="input-element"
                  type="options"
                  :options="[
                    {
                      value: 'B2B',
                      text: 'B2B'
                    },{
                      value: 'B2C',
                      text: 'B2C'
                    }
                  ]" 
                  label="License Type"
                  :disabled="!!account_id"
                  :key_ref="'license_type'"
                  :value="licenceEl?.license_type"
                  :error="data.license_type.error"
                  @inputChange="inputChangeFunc"
                ></InpComponent>
               
                <InpComponent
                  :noMargin="true"
                  class="input-element"
                    label="Licence Number"
                    type="text"
                    placeholder="6134543232"
                    :disabled="!!account_id"
                    :key_ref="'license_number'"
                    :value="licenceEl?.license_number"
                    :error="data.license_number.error"
                  @inputChange="inputChangeFunc"
                ></InpComponent>

                <InpComponent
                  :noMargin="true"
                  class="input-element"
                    label="Issue Date"
                    type="date"
                    :disabled="!!account_id"
                    :key_ref="'issueDate'"
                    :value="licenceEl?.issueDate"
                    :error="data.issueDate.error"
                  @inputChange="inputChangeFunc"
                ></InpComponent>

                <InpComponent
                  :noMargin="true"
                  class="input-element"
                    label="Expiration Date"
                    type="date"
                    :disabled="!!account_id"
                    :key_ref="'expiration_date'"
                    :value="licenceEl?.expiration_date"
                    :error="data.expiration_date.error"
                  @inputChange="inputChangeFunc"
                ></InpComponent>
          </div>
        </div>
        </div>
      <div class="flex column align-start gap-20 flex-1">
        <div class='section address-info-section'>
          <div class='section-header main-header'>
            <img src="@/assets/location.svg" style="margin-right: 10px;">
            <div>Address (addresses of the reporting entity)</div>
          </div>

          <div class="input-section">
            <!-- {text: 'Private', value: 'Private'}, 
            {text: 'Business', value: 'Business'},
            {text: 'Operational', value: 'Operational'},
            {text: 'IP Address', value: 'IP Address'} -->
                <InpComponent
                  :noMargin="true"
                  class="input-element"
                  label="Type"
                  type="options"
                  :options="[
                    {text: 'Business', value: 'Business'},
                  ]"
                  placeholder="Private"
                  
                  :disabled="!!account_id"
                  :key_ref="'address_type'"
                  :value="userAddress?.address_type"
                  :error="data.address_type.error"
                  @inputChange="inputChangeFunc"
                ></InpComponent>
                <InpComponent
                  :noMargin="true"
                  class="input-element"
                    label="Address"
                    type="text"
                    placeholder="Suite 1200, 407 2nd Street, SW Calgary"
                    
                    :disabled="!!account_id"
                    :key_ref="'address'"
                    :value="userAddress?.address"
                    :error="data.address.error"

                  @inputChange="inputChangeFunc"
                ></InpComponent>

                <InpComponent
                  :noMargin="true"
                  class="input-element"
                    label="Town"
                    type="text"
                    placeholder="Name of Town/district/.. as part of a City "
                    
                    :disabled="!!account_id"
                    :key_ref="'town'"
                    :value="userAddress?.town"
                    :error="data.town.error"

                  @inputChange="inputChangeFunc"
                ></InpComponent>
                <InpComponent
                  :noMargin="true"
                  class="input-element"
                    label="City"
                    type="text"
                    placeholder="Edmonton"
                    
                    :disabled="!!account_id"
                    :key_ref="'city'"
                    :value="userAddress?.city"
                    :error="data.city.error"
                  @inputChange="inputChangeFunc"
                ></InpComponent>
                <InpComponent
                  :noMargin="true"
                  class="input-element"
                  label="Zip"
                  type="text"
                  placeholder="00000"
                  
                  :disabled="!!account_id"
                  :key_ref="'zip'"
                  :value="userAddress?.zip"
                  :error="data.zip.error"
                  @inputChange="inputChangeFunc"
                ></InpComponent>
                <InpComponent
                  :noMargin="true"
                  class="input-element"
                  label="Country"
                  type="options"
                  :options="Utils && Utils.getCountryList()"
                  placeholder="Canada"
                  
                  :disabled="!!account_id"
                  :key_ref="'country'"
                  :value="userAddress?.country"
                  :error="data.country.error"
                  @inputChange="inputChangeFunc"
                ></InpComponent>
                <InpComponent
                  :noMargin="true"
                  class="input-element"
                  label="State"
                  type="text"
                  placeholder="Alberta"
                  
                  :disabled="!!account_id"
                  :key_ref="'state'"
                  :value="userAddress?.state"
                  :error="data.state.error"

                  @inputChange="inputChangeFunc"
                ></InpComponent>
          </div>
        </div>

        <div class='section phone-info-section'>
          <div class='section-header main-header'>
            <img src="@/assets/call.svg" style="margin-right: 10px;">

            <div>Phone</div>
          </div>
          <div class="input-section">
                <!-- {text: 'Operational', value: 'Operational'},
                {text: 'IP Address', value: 'IP Address'} -->
                <InpComponent
                  :noMargin="true"
                  class="input-element"
                  label="Contact type"
                  type="options"
                  :options="[
                    {text: 'Private', value: 'Private'}, 
                    {text: 'Business', value: 'Business'},
                  ]"
                  placeholder="Private"
                  
                  :disabled="!!account_id"
                  :key_ref="'phone_type'"
                  :value="userPhone?.phone_type"
                  @inputChange="inputChangeFunc"
                ></InpComponent>
                <InpComponent
                  :noMargin="true"
                  class="input-element"
                    label="Communication type"
                    type="options"
                    :options="[
                      {text: 'Mobile Phone', value: 'Mobile Phone'},
                      {text: 'Landline Phone', value: 'Landline Phone'},
                      {text: 'Fax', value: 'Fax'}, 
                    ]"
                    placeholder="Mobile Phone"
                    
                    :disabled="!!account_id"
                    :key_ref="'communication_type'"
                    :value="userPhone?.communication_type"
                  @inputChange="inputChangeFunc"
                ></InpComponent>
                <InpComponent
                  :noMargin="true"
                  class="input-element"
                  label="Country Prefix"
                  type="options"
                  :options="Utils.getCountryPrefixes()"
                  placeholder="1"
                  
                  :disabled="!!account_id"
                  :key_ref="'phone_prefix'"
                  :value="userPhone?.phone_prefix"
                  :error="data.phone_prefix.error"

                  @inputChange="inputChangeFunc"
                ></InpComponent>
                <InpComponent
                  :noMargin="true"
                  class="input-element"
                    label="Number"
                    type="number"
                    placeholder="6134543232"
                    :disabled="!!account_id"
                    :key_ref="'phone_number'"
                    :value="userPhone?.phone_number"
                    :error="data.phone_number.error"

                  @inputChange="inputChangeFunc"
                ></InpComponent>
          </div>
        </div>
        <div class='section phone-info-section' v-if="agreement || terms">
          <div class='section-header main-header'>
            <img src="@/assets/documents-black.svg" style="margin-right: 10px; width: 25px">

            <div>Documents</div>
          </div>
          <div class="flex column gap-10">
            <div v-if="agreement && agreement.admin_file_id && agreement.status == 'approved_and_signed'" class="flex column gap-5px" >
              <div class="text-left w-full font-size-16 bold">
                Signed agreement by both parties:
              </div>
              <div class='attachment  grayed w-full border-box' >
                <img src="@/assets/pdf-file.svg" class='fileicon pl-5'>
                <div class="filename">
                  <div class="name-of-the-file">
                    {{ agreement.admin_filename }}
                    <span class="label-status complete">Complete</span>
                  </div>
                  <div class="size-of-the-file">{{ Utils.calculateFileSize(agreement.admin_filesize) }}</div>
                </div>
                <div class="flex-1 flex justify-end p-10 pointer">
                  <img class='download' @click="downloadFile(agreement, 'final')" src="@/assets/download.svg"> 
                </div>
              </div>
            </div>

            <div v-else-if="agreement && agreement.user_file_id && ['under_review', 'rejected'].includes(agreement.status)" class="flex column gap-5px" >
             
              <div class='attachment  grayed w-full border-box' >
                <img src="@/assets/pdf-file.svg" class='fileicon pl-5'>
                <div class="filename">
                  <div class="name-of-the-file">
                    {{ agreement.user_filename }} 
                    <span class="label-status" v-if="!agreement.rejection_reason">Signed and sent, awaiting approval</span>
                    <span class="label-status" v-else>Rejected</span>
                  </div>
                  <div class="size-of-the-file">{{ Utils.calculateFileSize(agreement.user_filesize) }}</div>
                </div>
                <div class="flex-1 flex justify-end p-10 pointer">
                  <img class='download' @click="downloadFile(agreement, 'user')" src="@/assets/download.svg"> 
                </div>
              </div>
               <div v-if="agreement.rejection_reason" class="text-left w-full font-size-16" style="color: red">
                Rejection reason: {{ agreement.rejection_reason }}
              </div>
            </div>

            <div v-else-if="agreement &&agreement.file_id" class="flex column gap-5px" >
              <div class='attachment  grayed w-full border-box' >
                <img src="@/assets/pdf-file.svg" class='fileicon pl-5'>
                <div class="filename">
                  <div class="name-of-the-file">{{ agreement.filename }} 
                    <span class="label-status">Pending signature</span>
                  </div>
                  <div class="size-of-the-file">{{ Utils.calculateFileSize(agreement.filesize) }}</div>
                </div>
                <div class="flex-1 flex justify-end p-10 pointer">
                  <img class='download' @click="downloadFile(agreement)" src="@/assets/download.svg"> 
                </div>
              </div>
            </div>
          
            <div v-if="terms">
              <div class="text-left w-full font-size-16 bold">Terms and Conditions:</div>
              <div class='attachment  grayed w-full border-box' >
                <img src="@/assets/pdf-file.svg" class='fileicon pl-5'>
                <div class="filename">
                  <div class="name-of-the-file">{{ terms.filename }}</div>
                  <div class="size-of-the-file">{{ Utils.calculateFileSize(terms.filesize) }}</div>
                </div>
                <div class="flex-1 flex justify-end p-10 D Agreempointer">
                  <img class='download' @click="downloadFile(terms)" src="@/assets/download.svg"> 
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!agreement && user.is_super_user && props.account_id" class='section phone-info-section flex column gap-5'>
          <div class='section-header m-0 main-header'>
            <img src="@/assets/documents-black.svg" style="margin-right: 10px; width: 25px">
            <div>Upload Client Agreement</div>
          </div>
          <MultiFileUploader  type=".pdf" :single=true @sendFileInfo="getFiles" class="uploadfile" />
          <button class='buttons' @click="() => showConfirmUpload = true">Upload</button>
        </div>
      </div>
    </div>
    </div>
    <div class="button-area mt-20" v-if="!account_id">
      <div class="button-holder">
        <button class='button' type="submit" @click="saveChanges()">Save</button>
      </div>
    </div>


    <PopupCover v-if="showConfirmUpload" @close="showConfirmUpload = false">
      <PopupBody :style="{width: '450px'}" @close="showConfirmUpload = false">
        <template #header>
          <div class="w-full text-center">Are you sure you want to add this user agreement ?</div>
        </template>
        <template #body>
          <div class="popup-actions flex row gap-10">
            <button class="button transparent" @click="showConfirmUpload = false">Bo Back</button>
            <button class="button" @click="sendAgreementFile()">Yes</button>
          </div>
        </template>
          
      </PopupBody>
    </PopupCover>

    <PopupCover v-if="confirmVerify" @close="confirmVerify = false">
      <PopupBody :style="{width: '450px'}" @close="confirmVerify = false">
        <template #header>
          <div class="w-full text-center">Are you sure you want to verify the email?</div>
        </template>
        <template #body>
          <div class="popup-actions flex row gap-10">
            <button class="button transparent" @click="confirmVerify = false">Cancel</button>
            <button class="button" @click="confirmVerifyEmail()">Verify</button>
          </div>
        </template>
          
      </PopupBody>
    </PopupCover>

      <PopupCover v-if="saveInitiated" @close="saveInitiated = false">
        <PopupBody :style="{width: '450px'}" @close="saveInitiated = false">
          <template #header>
            <div class="w-full text-center">🔒 Confirm Permanent Configuration</div>
          </template>
          <template #body>
            <div class="popup-content">
              <div class="text-left mb-10 ">
                Once you confirm, <text v-if="frozenFieldsCount > 1">these values</text><text v-else> this value</text> will be permanently locked to this account and cannot be changed.
              </div>
              <div class="value-freezed flex row gap-10 align-start mb-10 font-size-16">
                <div class="flex gap-10 flex-1" v-if="data.rentity_id.value && !userInformation.rentity_id"><div>🔒</div> <div class="flex column align-start"><div>Entity ID</div> <div>{{ data.rentity_id.value }}</div></div></div>
                <div class="separator" v-if="frozenFieldsCount > 1"></div>
                <div class="flex gap-10 flex-1" v-if="data.rentity_branch.value && !userInformation.rentity_branch"><div>🔒</div> <div class="flex column align-start"><div>Entity Name </div><div>{{ data.rentity_branch.value }}</div></div></div>
              </div>
              <div class="confirmation flex row gap-10 align-start mb-10">
                <input type="checkbox" id="confirmation" v-model="confirmationChecked" ref="confirmationCheckbox">
                <div class="text-left" @click="$refs.confirmationCheckbox.click()">I understand <text v-if="frozenFieldsCount > 1">these values</text><text v-else> this value</text> will be permanently locked </div>
              </div>
            </div>
            <div class="popup-actions flex row gap-10">
              <button class="button transparent" @click="saveInitiated = false">Cancel</button>
              <button :disabled="!confirmationChecked" class="button" @click="confirmSave()">Lock Configuration</button>
            </div>
            <div class="warning-bottom mt-10 font-size-12">
              Future changes require manual support review.
            </div>
          </template>
        </PopupBody>
      </PopupCover>
  </div>
</template>

<script setup>
// @ is an alias to /src
import API from '@/api/index.js'
import BO_API from '../api/bo_api.js'
import InpComponent from '@/components/InpComponent.vue'
import ConfirmEmail from '@/components/confirmEmail.vue'
import Utils from '@/utils/index.js'

import consts from '../../../shared/consts.js'

import PopupBody from '@/components/PopupBody.vue';
import PopupCover from '@/components/PopupCover.vue';

import MultiFileUploader from '@/components/MultifileUploader.vue'

import store from '../store';
import { ref, defineProps, onMounted, computed, watch } from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter();

const props = defineProps(['account_id'])
const user = computed(() => store.state.user)
const saveInitiated = ref(false);
const confirmationChecked = ref(false);

const userInformationStore = computed(() => store.state.userInformation)
const userAddressStore = computed(() => store.state.userAddress)
const userPhoneStore = computed(() => store.state.userPhone)
const licenceStore = computed(() => store.state.licenceElem)
const agreementStore = computed(() => store.state.agreements && store.state.agreements.find(el => el.type == 'agreement'));
const termsStore = computed(() => store.state.agreements && store.state.agreements.find(el => el.type == 'terms'));

const missingUserInfoFields = computed(() => store.getters.missingUserInfoFields)

const selectedFile = ref(null);

const accountInfo = ref(null);
const accountAddress = ref(null);
const accountPhone = ref(null);
const accountLicence = ref(null);
const accountAgreements = ref(null);

const confirmVerify = ref(false);

const showConfirmUpload = ref(false);

const userInformation = computed(() => {
  return props.account_id ? accountInfo.value : userInformationStore.value
})
const userAddress = computed(() => {
  return props.account_id ? accountAddress.value : userAddressStore.value
})
const userPhone = computed(() => {
  return props.account_id ? accountPhone.value : userPhoneStore.value
})
const licenceEl = computed(() => {
  return props.account_id ? accountLicence.value : licenceStore.value
})
const agreement = computed(() => {
  return props.account_id ? accountAgreements.value ? accountAgreements.value.find(el => el.type == 'agreement') : null : agreementStore.value
})
const terms = computed(() => {
  return props.account_id ? accountAgreements.value ? accountAgreements.value.find(el => el.type == 'terms') : null : termsStore.value
})
const showAgreement = computed(() => {
  return (agreement && agreement.value?.accepted === false) && userInformation.value && userInformation.value.email_verified && missingUserInfoFields.value.length == 0
})



const data = ref({
  rentity_id: {value: '', error: '', checkActive: false, },
  rentity_branch: {value: '', error: '', checkActive: false },
  title_name: {value: '', error: '', checkActive: false },
  first_name: {value: '', error: '', checkActive: false },
  last_name: {value: '', error: '', checkActive: false },
  email: {value: '', error: '', checkActive: false },
  gender: {value: '', error: '', checkActive: false },
  birth_date_day: {value: '', error: '', checkActive: false },
  birth_date_month: {value: '', error: '', checkActive: false },
  birth_date_year: {value: '', error: '', checkActive: false },
  birth_date_full: {value: '', error: '', checkActive: false },
  id_number: {value: '', error: '', checkActive: false },
  nationality: {value: '', error: '', checkActive: false },
  occupation: {value: '', error: '', checkActive: false },
  passport_number: {value: '', error: '', checkActive: false },
  pasport_country: {value: '', error: '', checkActive: false },
  local_currency: {value: '', error: '', checkActive: false },

  address_type: {value: '', error: '', checkActive: false },
  address: {value: '', error: '', checkActive: false },
  town: {value: '', error: '', checkActive: false },
  city: {value: '', error: '', checkActive: false },
  zip: {value: '', error: '', checkActive: false },
  country: {value: '', error: '', checkActive: false },
  state: {value: '', error: '', checkActive: false },

  phone_type: {value: '', error: '', checkActive: false },
  communication_type: {value: '', error: '', checkActive: false },
  phone_prefix: {value: '', error: '', checkActive: false },
  phone_number: {value: '', error: '', checkActive: false },

  issuing_authority: {value: '', error: '', checkActive: false },
  license_type: {value: '', error: '', checkActive: false },
  license_number: {value: '', error: '', checkActive: false },
  issueDate: {value: '', error: '', checkActive: false },
  expiration_date: {value: '', error: '', checkActive: false },
  
})


const frozenFieldsCount = computed( () => {
  let count = 0;
  if (userInformation.value) {
    if (!userInformation.value.rentity_id && data.value.rentity_id.value) {
      count++;
    }
    if (!userInformation.value.rentity_branch && data.value.rentity_branch.value) {
      count++;
    }
  }
  return count;
}) 
  
function getFiles(files) {
  selectedFile.value = files[0];
}
async function sendAgreementFile(){
  const response = await API.uploadAgreement(selectedFile.value, props.account_id);
  selectedFile.value = null;
  showConfirmUpload.value = false;
  if (response.agreement) {
    accountAgreements.value.push(response.agreement)
  }
}

function inputChangeFunc(value) {
  let updated = false;
  if (value[0] == 'birth_date_day' && data.value.birth_date_day.value && value[1] > 31 ) {
    data.value.birth_date_day.value = 31;
    updated = true;
  }
  if (value[0] == 'birth_date_month' && data.value.birth_date_month.value && value[1] > 12) {
    data.value.birth_date_month.value = 12;
    updated = true;
  }
  if (value[0] == 'birth_date_day' && data.value.birth_date_day.value && value[1] < 1) {
    data.value.birth_date_day.value = 1;
    updated = true;
  }
  if (value[0] == 'birth_date_month' && data.value.birth_date_month.value && value[1] < 1) {
    data.value.birth_date_month.value = 1;
    updated = true;
  }
  if (!updated) {
    data.value[value[0]].value = value[1]
  }
  if (['birth_date_day', 'birth_date_month', 'birth_date_year'].includes(value[0])) {

    if (data.value.birth_date_day.value && data.value.birth_date_month.value && data.value.birth_date_year.value && data.value.birth_date_year.value.toString().length > 3) {
      let date;
      try {
        const dateErrors = Utils.isValidDate(data.value.birth_date_year.value, data.value.birth_date_month.value, data.value.birth_date_day.value);
        if (dateErrors) {
          store.dispatch('addNotification', {type: 'error', text: dateErrors})
          return;
        }
        let month = data.value.birth_date_month.value < 10 ? '0' + data.value.birth_date_month.value.toString() : data.value.birth_date_month.value;
        let day = data.value.birth_date_day.value < 10 ? '0' + data.value.birth_date_day.value.toString() : data.value.birth_date_day.value;
        let full = data.value.birth_date_year.value + '-' + month + '-' + day;
        let date = new Date(full);

        data.value.birth_date_full.value = date.toISOString();
      } catch (e) {
        console.log('error', 'incorrect date format', e)
      }
    }
  }
  if (data.value[value[0]].checkActive) {
    validateData(value[0])
  }
}

async function downloadFile(file, type) {
  await API.downloadAgreementFile(file.id, type == 'user' ? file.user_filename : file.filename, type)
}

function validateData(propName) {
  let propertyName = propName;
  const validator = {
    rentity_id: function(){
      data.value.rentity_id.error = Utils.validateEntityId(data.value.rentity_id.value)
    },
    rentity_branch: function(){
      data.value.rentity_branch.error = Utils.validateEntityName(data.value.rentity_branch.value)
    },
    title_name: function(){
      data.value.title_name.error = Utils.validateTitle(data.value.title_name.value)
    },
    first_name: function(){
      data.value.first_name.error = Utils.validateInputName(data.value.first_name.value, 'first_name')
    },
    last_name: function(){
      data.value.last_name.error = Utils.validateInputName(data.value.last_name.value, 'last_name')
    },
    email: function(){
      const email_validation_passed = Utils.validateEmail(data.value.email.value);
      if (email_validation_passed) {
        data.value.email.error = '';
      } else {
        data.value.email.error = 'Please provide a valid email';
      }
    },
    gender: function() {
      if (!data.value.gender.value) {
        data.value.gender.error = 'Please select a gender';
      }
    },
    birth_date_full: function(){
      data.value.birth_date_full.error = Utils.isValidDate(data.value.birth_date_year.value, data.value.birth_date_month.value, data.value.birth_date_day.value)
    },
    id_number: function(){
      data.value.id_number.error = Utils.validateIdNumber(data.value.id_number.value)
    },
    nationality: function(){
      if (!data.value.nationality.value) {
        data.value.nationality.error = 'Please select a nationality';
      }
    },
    occupation: function(){
      data.value.occupation.error = Utils.validateOccupation(data.value.occupation.value)
    },
    passport_number: function(){
      data.value.passport_number.error = Utils.validatePassportNumber(data.value.passport_number.value)
    },
    pasport_country: function(){
      if (data.value.passport_number.value && !data.value.pasport_country.value) {
        data.value.pasport_country.error = 'Please select a country';
      }
    },
  
    address_type: function(){
      if (!data.value.address_type.value) {
        data.value.address_type.error = 'Please select an address type';
      }
    },
    address: function(){
      data.value.address.error = Utils.validateAddress(data.value.address.value)
    },
    town: function(){
      data.value.town.error = Utils.validateTown(data.value.town.value)
    },
    city: function(){
      data.value.city.error = Utils.validateCity(data.value.city.value)
    },
    zip: function(){
      data.value.zip.error = Utils.validateZip(data.value.zip.value)
    },
    state: function(){
      data.value.state.error = Utils.validateState(data.value.state.value)
    },

    country: function(){
      if (!data.value.country.value) {
        data.value.country.error = 'Please select a country';
      }
    },
    phone_type: function(){
      if (!data.value.phone_type.value) {
        data.value.phone_type.error = 'Please select a phone type';
      }
    },
    communication_type: function(){
      if (!data.value.communication_type.value) {
        data.value.communication_type.error = 'Please select a communication type';
      }
    },
    phone_prefix: function(){
      if (!data.value.phone_prefix.value) {
        data.value.phone_prefix.error = 'Please select a country prefix';
      }
    },
    phone_number: function(){
      data.value.phone_number.error = Utils.validatePhoneNumber(data.value.phone_number.value)
    },
  };
  let hasError = '';

  if (propertyName) {
    validator[propertyName]()
    if (data.value[propertyName].error) {
      data.value[propertyName].checkActive = true;
      hasError = data.value[propertyName].error;
    }
  } else {
    for (let key in validator) {
      if (!data.value[key].value) {
        continue;
      }
      validator[key]()
      if (data.value[key].error) {
        data.value[key].checkActive = true;
        hasError = data.value[key].error;
      }
    }
  }
  return hasError;
}
async function sateValues(){
  const resp = await API.saveUserChanges({
    rentity_id: data.value.rentity_id.value,
    rentity_branch: data.value.rentity_branch.value,
    title_name: data.value.title_name.value,
    first_name: data.value.first_name.value,
    last_name: data.value.last_name.value,
    email: data.value.email.value,
    gender: data.value.gender.value,
    birth_date: data.value.birth_date_full.value ? data.value.birth_date_full.value : '',
    id_number: data.value.id_number.value,
    nationality: data.value.nationality.value,
    occupation: data.value.occupation.value,
    passport_number: data.value.passport_number.value,
    pasport_country: data.value.pasport_country.value,
    address_type: data.value.address_type.value,
    address: data.value.address.value,
    town: data.value.town.value,
    city: data.value.city.value,
    zip: data.value.zip.value,
    country: data.value.country.value,
    state: data.value.state.value,
    local_currency: data.value.local_currency.value,


    phone_type: data.value.phone_type.value,
    communication_type: data.value.communication_type.value,
    phone_prefix: data.value.phone_prefix.value,
    phone_number: data.value.phone_number.value,

    issuing_authority: data.value.issuing_authority.value,
    license_type: data.value.license_type.value,
    license_number: data.value.license_number.value,
    issueDate: data.value.issueDate.value,
    expiration_date: data.value.expiration_date.value,
  })
}
async function saveChanges() {
  for (let key in data.value){
    if (data.value[key] && data.value[key].checkActive) {
      data.value[key].checkActive = false;
    }
  }
  const validationResultsErrors = validateData(null);
  if (validationResultsErrors) {
    store.dispatch('addNotification', {type: 'error', text: "Check provided data"})
    return
  }
  if ((!userInformation.value.rentity_branch && data.value.rentity_id.value) || (!userInformation.value.rentity_id && data.value.rentity_branch.value)) {
    saveInitiated.value = true;
    return; 
  }
  await sateValues();
}



async function verifyEmail(){
  confirmVerify.value = true;
}

async function confirmVerifyEmail(){
  const result = await BO_API.confirmEmailVerification(props.account_id);
  if (result.status == 'success') {
    store.dispatch('addNotification', {type: 'success', text: "Email verified successfully"});
    confirmVerify.value = false;
  }
}


async function confirmSave() {
  if (!confirmationChecked.value) {
    store.dispatch('addNotification', {type: 'error', text: "Please confirm that the Entity ID and Entity Name are correctly set."})
    return;
  }
  await sateValues();
  saveInitiated.value = false;
}   


function setValues() {
  data.value.rentity_id.value = userInformation.value?.rentity_id;
  data.value.rentity_branch.value = userInformation.value?.rentity_branch;
  data.value.title_name.value = userInformation.value?.title_name;
  data.value.first_name.value = userInformation.value?.first_name;
  data.value.last_name.value = userInformation.value?.last_name;
  data.value.email.value = userInformation.value?.email;
  data.value.gender.value = userInformation.value?.gender;
  data.value.birth_date_full.value = userInformation.value?.birth_date;
  data.value.birth_date_day.value = userInformation.value?.birth_date ? userInformation.value?.birth_date.slice(0,10).split('-')[2] : '';
  data.value.birth_date_month.value = userInformation.value?.birth_date ?userInformation.value?.birth_date.slice(0,10).split('-')[1] : '';
  data.value.birth_date_year.value = userInformation.value?.birth_date ?userInformation.value?.birth_date.slice(0,10).split('-')[0] : '';

  data.value.id_number.value = userInformation.value?.id_number;
  data.value.nationality.value = userInformation.value?.nationality;
  data.value.occupation.value = userInformation.value?.occupation;
  data.value.passport_number.value = userInformation.value?.passport_number;
  data.value.pasport_country.value = userInformation.value?.pasport_country;
  data.value.local_currency.value = userInformation.value?.local_currency;

  data.value.address_type.value = userAddress.value?.address_type;
  data.value.address.value = userAddress.value?.address;
  data.value.town.value = userAddress.value?.town;
  data.value.city.value = userAddress.value?.city;
  data.value.zip.value = userAddress.value?.zip;
  data.value.country.value = userAddress.value?.country;
  data.value.state.value = userAddress.value?.state;

  data.value.phone_type.value = userPhone.value?.phone_type;
  data.value.communication_type.value = userPhone.value?.communication_type;
  data.value.phone_prefix.value = userPhone.value?.phone_prefix;
  data.value.phone_number.value = userPhone.value?.phone_number;


  data.value.issuing_authority.value = licenceEl.value?.issuing_authority;
  data.value.license_type.value = licenceEl.value?.license_type;
  data.value.license_number.value = licenceEl.value?.license_number;
  data.value.issueDate.value = licenceEl.value?.issueDate;
  data.value.expiration_date.value = licenceEl.value?.expiration_date;


}
onMounted(async () => {
  if (!user.value) {
    router.push('/')
  }

  if (props.account_id){
    const response = await API.getAccount(props.account_id)
    accountInfo.value = response.userInformationItem;
    accountAddress.value = response.userAddressItem;
    accountPhone.value = response.userPhoneItem;
    accountLicence.value = response.licenceElem;
    console.log('response.agreements', response.agreements)
    accountAgreements.value = response.agreements;
  }
  setValues();
})
</script>

<style scoped lang="scss">
  @use '@/assets/_css/file.scss';

.verify-button {
  width: 120px;
  min-width: 120px;
  margin-left: 20px;
  height: 35px;
  margin-top: 10px;
}
.home {
  height: fit-content;
}
.date {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  &:deep(input){
    width: 70%;
    margin-right: 5px;
  }
}
.input-holder {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.button-holder {
  width: 80px;
  height: 40px;

  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: auto;
  button {
    height: 40px;

  }
}

.input-section {
  box-sizing: border-box;
  display: grid;
  grid-template-columns: repeat(2, minmax(150px, 1fr));
  gap: 20px;
}
.input-wrapper {
  flex: 1;  

}



.section {
  width: 100%;
  background-color: white;
  padding: 20px;
  box-sizing: border-box;
  border: 1px solid var(--border-color);
  border-radius: 10px;
  height: fit-content;
}

.section-header {
  color: black;
  font-size: 16px;
  text-align: left;
  font-weight: bold;
  margin: 20px 0;
  display: flex;
  border-bottom: 0.5px solid var(--border-color);
  padding-bottom: 5px;
}
.error {
  margin-bottom: -10px;
  color: red;
  font-size: 10px;
}
.text {
  color: #3D5873;
  font-size: 11px;
  margin-right: 5px;
  margin-top: -11px;
}
.view-wrap {
  max-width: 1350px;
  margin: 0 auto;
  display: flex;
  justify-content: flex-start;
}
.main-header {
  margin-top: 0px;
}
.bd-header {
  margin-left: 10px;
}
.disclaimer {
  box-shadow: 0px 0px 1.5px 0px #949494;
  padding: 20px;
  width: 100%;
  border-radius: 10px;
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
  align-items: flex-start;
  background-color: white;
  // background-color: #FEF4F5;
}
.req-warning {
  color: black;

  font-size: 20px;
  font-weight: 600;
  display: flex;
  align-items: center;
  img {
      margin-right: 20px;
  }
}
.warning-point {
  padding-left: 40px;
  font-size: 14px;
  font-weight: 500;
  margin-left: 25px;
  position: relative;
  &::before {
      content: '';
      position: absolute;
      left: 25px;
      top: 8px;
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background: #BB3530;
  }
}
.disclaimer-text {
  padding-top: 3px;
  font-size: 14px;
  font-weight: 500;
  padding-left: 47px;
  text-align: left;
}
.disclaimer-body {
    background-color: #FAF7F6;
    padding: 20px;
    border-radius: 10px;
    box-sizing: border-box;
}
.header-section {
  // padding: 0 20px;
  height: 50px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  margin-bottom: -20px;
  max-width: 1350px;
  width: 100%;
  box-sizing: border-box;
  margin: auto;
}
.kyc-header {
  max-width: 1350px;
  width: 100%;
  text-align: left;
  font-size: 28px;
  position: relative;
  color: black;

  gap: 10px;
  display: flex;
  flex-direction: column;
}

.value-freezed {
  background-color: white;
  border: 1px solid  var(--border-color);
  padding: 10px 20px; 
  border-radius: 5px;
  color: black;
  font-weight: bold;
  font-size: 15px;
}
.separator {
  width: 1px;
  height: 44px;
  background-color: var(--border-color);
  margin: 0 10px;
}
.warning-bottom {
  margin-top: 10px;
  font-size: 12px;
  color:#949494;
}
.label-status {
  font-size: 13px;
  color: black;
  margin-left: 10px;
  padding: 3px 10px;
  border-radius: 5px;
  background-color: #e0c2c2;
  &.complete {
    background-color: #c2e0c2;
  }
}
</style>